/**
 * AI 花字入口：开启高级 AI 能力且当前非图片图层时展示（如文本层等），点击打开 AI 花字插件。
 */
import React from 'react';
import { LayerType, PluginEnum, type IImageLayerProps } from '@/version-types';
import { type ShortcutMenu } from '../shortcut-menu';
import { SHORTCUT_FUNC_MAP, type IShortcutMenuItemRenderArgs } from '../type';
import { ShortcutToolbarAiTextItem } from '../views/shortcut-toolbar-widgets';

export const aiTextShortcutItemRender = ({ framework, layer, advancedAiEnabled }: IShortcutMenuItemRenderArgs) => {
    const isImageLayer = layer.layerType === LayerType.IMAGE_LAYER;
    const hasAiText =
        (layer.layerType === LayerType.IMAGE_LAYER && (layer.data as IImageLayerProps).aiTextExtension) ||
        layer.layerType === LayerType.TEXT_LAYER;

    if (!advancedAiEnabled || !hasAiText || isImageLayer) return null;

    const onAi = (e: React.MouseEvent) => {
        e.stopPropagation();
        framework.service.registration
            .getInstance<ShortcutMenu>('ShortcutMenu')
            .emitClick(SHORTCUT_FUNC_MAP.AI_TEXT)
            .openPlugin({ func: PluginEnum.AI_TEXT });
    };

    return <ShortcutToolbarAiTextItem onClick={onAi} />;
};
